import { render } from "./TopBars.vue?vue&type=template&id=7f1ff5cc"
import script from "./TopBars.vue?vue&type=script&lang=js"
export * from "./TopBars.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Giant\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__